<script>

    import {createEventDispatcher, onMount} from 'svelte';
    import Common from "../Common";

    export let rent;

    const dispatch = createEventDispatcher();

    function back() {
        dispatch('back', {});
    }

    function pay() {
        Common.getPaymentUrlForRent(rent.uuid).then(function (response) {
            back();
            window.open(response.value, '_self');
        });
    }

</script>

<main class="flex flex-row w-full flex-wrap drogowskazFont h-full justify-evenly">

    <div class="flex flex-row w-full">
        <div class="h-full  w-2/4  flex flex-col bg-white text-center justify-center">
            <div>
                <br/>
            </div>
            <div>
                <img src="/logo.png"/>
            </div>
            <div>
                <br/>
            </div>
        </div>
        <div class="h-full w-2/4 flex flex-col bg-blue-1  text-center justify-center" on:click={back}>
            <div>
                <span class="text-2xl md:text-3xl"><i class="fas fa-arrow-left blue-3 mr-4"></i>Wstecz</span>
            </div>
        </div>
    </div>

    <div class="flex flex-row w-full bg-blue-2 white text-white  text-base text-center justify-center py-4">
    </div>

    <div class="flex flex-row w-full bg-blue-3 white text-white  text-base text-center justify-center py-4">
        <div class="w-1/4 text-center flex flex-col justify-center items-center">
            <i class="fas fa-dollar-sign fa-3x blue-2"></i>
        </div>
        <div class="w-3/4 text-center justify-center flex flex-col" on:click={pay}>
            <span class="text-2xl">Płacę teraz {rent.price - rent.paid} PLN</span>
        </div>
    </div>

    <div class="flex flex-row w-full bg-blue-2 white text-white  text-base text-center justify-center py-4">
    </div>

</main>
